const SET_LIST = (state, payload) => {
  state.list = payload
}

const SET_PERMISSIONS = (state, permissions) => {
  state.permissions = permissions
}

const SET_CURRENT_USER = (state, user) => {
  state.current = {
    ...user,
    assignor: {
      ...user.assignor,
      is_progress: !user.assignor ? false : user.assignor.assignor_type === 'pending' && user.assignor.status_documentation === 'all_sended',
      is_pending: !user.assignor ? false : user.assignor.assignor_type === 'pending' && (user.assignor.status_documentation === 'none_doc' || user.assignor.status_documentation === 'incomplete'),
      is_done: !user.assignor ? false : user.assignor.assignor_type === 'complete'
    }
  }
}

export default {
  SET_LIST,
  SET_PERMISSIONS,
  SET_CURRENT_USER
}



// WEBPACK FOOTER //
// ./src/features/profile/store/mutations.js